import { render, staticRenderFns } from "./TransferPiecesModal.vue?vue&type=template&id=0cb7d38a&"
import script from "./TransferPiecesModal.vue?vue&type=script&lang=js&"
export * from "./TransferPiecesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports